import validate from "/home/renato/projects/apps/pj/cf236/general/general/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/renato/projects/apps/pj/cf236/general/general/middleware/auth.global.ts";
import redirect_45root_45global from "/home/renato/projects/apps/pj/cf236/general/general/middleware/redirect-root.global.ts";
import manifest_45route_45rule from "/home/renato/projects/apps/pj/cf236/general/general/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  redirect_45root_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  permissions: () => import("/home/renato/projects/apps/pj/cf236/general/general/middleware/permissions.ts"),
  "validate-token": () => import("/home/renato/projects/apps/pj/cf236/general/general/middleware/validate-token.ts")
}